var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_16760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.643994C22.3139 0.644523 22.6743 0.7941 22.9401 1.05991C23.2059 1.32572 23.3555 1.6861 23.356 2.06201V21.938C23.3555 22.3139 23.2059 22.6743 22.9401 22.9401C22.6743 23.2059 22.3139 23.3555 21.938 23.356H2.06201C1.6861 23.3555 1.32572 23.2059 1.05991 22.9401C0.7941 22.6743 0.644523 22.3139 0.643994 21.938V2.06201C0.644523 1.6861 0.7941 1.32572 1.05991 1.05991C1.32572 0.7941 1.6861 0.644523 2.06201 0.643994H21.938ZM21.938 0H2.06201C1.5153 0.000529505 0.991126 0.217956 0.604541 0.604541C0.217956 0.991126 0.000529505 1.5153 0 2.06201V21.938C0.000529505 22.4847 0.217956 23.0089 0.604541 23.3955C0.991126 23.782 1.5153 23.9995 2.06201 24H21.938C22.4845 23.9989 23.0084 23.7813 23.3949 23.3949C23.7813 23.0084 23.9989 22.4845 24 21.938V2.06201C23.9995 1.5153 23.782 0.991126 23.3955 0.604541C23.0089 0.217956 22.4847 0.000529505 21.938 0Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0342 23.356H21.9382C22.3141 23.3555 22.6745 23.2059 22.9403 22.9401C23.2061 22.6743 23.3557 22.3139 23.3562 21.938V20.488L16.0342 16.828V23.356Z",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96558 0.643993H2.06157C1.68566 0.644522 1.32528 0.794099 1.05947 1.05991C0.793661 1.32572 0.644084 1.6861 0.643555 2.06201V3.72002L7.96558 7.37998V0.643993Z",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9382 0.643993H16.0342V7.37998L23.3562 3.71802V2.06201C23.3557 1.6861 23.2061 1.32572 22.9403 1.05991C22.6745 0.794099 22.3141 0.644522 21.9382 0.643993Z",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643555 20.488V21.938C0.644084 22.3139 0.793661 22.6743 1.05947 22.9401C1.32528 23.2059 1.68566 23.3555 2.06157 23.356H7.96558V16.828L0.643555 20.488Z",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4219 23.356H16.0338V16.828L23.3559 20.488V17.792L20.0318 16.13H23.3559V14.538H14.4219V23.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643555 14.538V17.8L3.98154 16.13H7.57554L0.643555 19.598V20.488L7.96357 16.828V23.356H9.57754V14.538H0.643555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57754 0.643993H7.96357V7.37998L0.643555 3.72002V6.42998L3.94556 8.07998H0.643555V9.69199H9.57754V0.643993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0338 0.643993H14.4219V9.69199H23.3559V6.43799L20.0699 8.07998H16.4438L23.3559 4.62202V3.71802L16.0338 7.37998V0.643993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0704 8.07998L23.3563 6.43799V4.62202L16.4443 8.07998H20.0704Z",
    fill: "#DE0034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643555 6.42998V8.07998H3.94556L0.643555 6.42998Z",
    fill: "#DE0034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98154 16.13L0.643555 17.8V19.598L7.57554 16.13H3.98154Z",
    fill: "#DE0034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3563 17.792V16.13H20.0322L23.3563 17.792Z",
    fill: "#DE0034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4216 0.643993H9.57754V9.69199H0.643555V14.538H9.57754V23.356H14.4216V14.538H23.3556V9.69199H14.4216V0.643993Z",
    fill: "#DE0034"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_16760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.dede23003b434ca4ce85519b2bf0d7f2.svg";
export { ForwardRef as ReactComponent };